import { cn } from '@/utils';
import React, { useEffect, useState } from 'react';
import { useMobileResponsive } from '@/hooks';
import { useRouter } from 'next/router';
import qrImage from '../../assets/new-assets/home/hero/qrImageOrg.webp';

const DownloadFooter = () => {
  const router = useRouter();
  const [isOutOfBounds, setIsOutOfBounds] = useState(false);
  const [showQr, setShowQr] = useState(false);
  const { isMobile } = useMobileResponsive();

  useEffect(() => {
    const handleScroll = () => {
      const isHomePage = router.pathname === `/`;

      if (!isHomePage) {
        setShowQr(false);
        return;
      }

      if (window.scrollY < 450 || window.scrollY > 5000) {
        setIsOutOfBounds(true);
        setShowQr(false);
      } else {
        setIsOutOfBounds(false);
        setShowQr(true);
      }
    };

    window.addEventListener(`scroll`, handleScroll);
    return () => window.removeEventListener(`scroll`, handleScroll);
  }, [isMobile, isOutOfBounds, router.pathname, showQr]);

  // Hide footer for these paths entirely
  const hiddenPaths = [`/course`, `/course/success`];
  const shouldHideFooter = hiddenPaths.includes(router.pathname);

  if (shouldHideFooter) return null;

  return (
    <>
      {showQr && (
        <div
          className={cn(
            `fixed bottom-4 right-4 w-32 p-4 border border-[#CDCDCD] flex justify-center bg-gradient-to-br from-[#2A105F] to-[#0F0622] rounded-3xl`,
            {
              hidden: isMobile,
            },
          )}
          style={{
            zIndex: 50,
          }}
        >
          <div className="flex items-center justify-center">
            <img alt="Qr code" src={qrImage.src} className="w-24" />
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadFooter;
